<template>
  <div class="speechContainer">
    <header>话术管理</header>
    <main>
      <div class="classification">
        <div class="title">话术分类</div>
        <Tree mode="edit" ref="RefTree" @handleChange="handleChange" />
      </div>
      <div class="content">
        <div class="search">
          <a-form ref="formRef" layout="inline" :model="formState">
            <a-form-item label="话术ID" name="id">
              <a-input
                :maxlength="10"
                v-model:value="formState.id"
                placeholder="请输入话术ID"
                allowClear
              ></a-input>
            </a-form-item>
            <a-form-item label="话术内容" name="chatContent">
              <a-input
                :maxlength="20"
                v-model:value="formState.chatContent"
                placeholder="请输入话术内容"
                allowClear
              ></a-input>
            </a-form-item>
            <a-form-item class="action">
              <a-button @click="resetForm" class="default-btn">重置</a-button>
              <a-button
                @click="
                  () => {
                    initPageParams()
                    pageList()
                  }
                "
                type="primary"
              >
                查询
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="table" ref="tableBox">
          <div class="action">
            <a-button @click="RefImport.showModal()" class="default-btn">导入话术</a-button>
            <a-button @click="RefUpdate.showModal()" type="primary">添加话术</a-button>
          </div>
          <a-table
            :pagination="pagination"
            :rowKey="record => record.id"
            :dataSource="dataSource"
            :columns="columnSpeach"
            @change="onChangePage"
            :scroll="{ x: '100%', y: tableBoxHeight - 216 }"
          >
            <template #action="action">
              <div class="table-action">
                <a-button type="link" @click="RefUpdate.showModal(action.record)">编辑</a-button>
                <a-button type="link" @click="del(action.record)">删除</a-button>
              </div>
            </template>
          </a-table>
        </div>
      </div>
    </main>
    <Import ref="RefImport" @getPageList="pageList" />
    <Update ref="RefUpdate" @getPageList="pageList" />
  </div>
</template>
<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { getPageList, addPhraseClassify } from '@/api/Speach/index.js'
import { reactive, ref, createVNode, onMounted, computed, watch } from 'vue'
import { message } from 'ant-design-vue'
import { columnSpeach } from './config'
import { Modal } from 'ant-design-vue'
import Tree from './Tree.vue'
import Import from './Import.vue'
import Update from './Update.vue'
//初始化
onMounted(() => {
  pageList()
})
//分配配置
const pagination = computed(() => ({
  total: pageParams.total,
  current: pageParams.pageNo,
  pageSize: pageParams.pageSize,
  showTotal: pageParams.showTotal,
  showSizeChanger: true,
  showQuickJumper: true
}))
//分配参数
const pageParams = reactive({
  total: 0,
  pageNo: 1,
  pageSize: 10,
  showTotal: () => {}
})
//导入弹窗
const RefImport = ref(null)
//新增编辑弹窗
const RefUpdate = ref(null)
//左侧分类菜单
const RefTree = ref(null)
//表单
const formRef = ref(null)
//Table父级
const tableBox = ref({})
//Table父级实例高度
const tableBoxHeight = ref(0)
//话术分类选中值
const selectPhraseId = ref(null)
//动态设置表单滚动值
setTimeout(() => {
  tableBoxHeight.value = (tableBox.value && tableBox.value.clientHeight) || 0
}, 0)
//主数据
const dataSource = ref([])
//表单值
const formState = reactive({
  id: null,
  chatContent: null
})
watch(
  () => formState.id,
  val => {
    formState.id = val && val.replace(/\D/g, '')
  }
)
//初始化分页参数
const initPageParams = () => {
  Object.assign(pageParams, { total: 0, pageNo: 1, pageSize: 10 })
}
//重置
const resetForm = () => {
  formRef.value.resetFields()
  initPageParams()
  pageList()
}
//分类切换
const handleChange = e => {
  initPageParams()
  formRef.value.resetFields()
  if (e === -1 || !e) {
    selectPhraseId.value = null
    pageList()
    return
  }
  selectPhraseId.value = e
  pageList()
}
//删除
const del = ({ id, phraseName, phraseLevel, chatContent, classifyId }) => {
  Modal.confirm({
    title: '删除确认',
    icon: createVNode(ExclamationCircleOutlined),
    content: '确定删除该话术吗？',
    okText: '确定',
    cancelText: '取消',
    centered: true,
    onOk: () => {
      addPhraseClassify({ id, phraseName, phraseLevel, delFlag: 1, chatContent, classifyId }).then(
        () => {
          initPageParams()
          pageList()
          message.success('删除成功')
        }
      )
    }
  })
}
// 分页参数修改
const onChangePage = page => {
  const { current, pageSize } = page || {}
  Object.assign(pageParams, { pageNo: current, pageSize })
  pageList()
}
//获取话术列表
const pageList = () => {
  RefTree.value.leftTree()
  const { pageNo, pageSize } = pageParams
  const classifyId = selectPhraseId.value
  getPageList({ classifyId, pageNo, pageSize, ...formState }).then((res = {}) => {
    const { pageNum, pageSize, total } = res
    Object.assign(pageParams, { pageNo: pageNum, pageSize, total })
    dataSource.value = res.list || []
    pageParams.showTotal = () => `共${total}条`
  })
}
</script>
<style lang="scss" scoped>
.speechContainer {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  header {
    padding: 24px;
    background: #ffffff;
    font-size: 20px;
    color: #262626;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
    font-weight: 500;
  }
  main {
    margin: 24px 0;
    padding: 0 24px;
    display: flex;
    justify-content: space-between;
    flex: 1;
    overflow: hidden;
    .classification {
      width: 300px;
      background: #fff;
      box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      .title {
        padding: 28px 24px;
        font-weight: 500;
        font-size: 18px;
        color: #262626;
      }
    }
    .content {
      flex: 1;
      margin-left: 16px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      overflow: hidden;
      .search {
        padding: 28px 24px;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
        ::v-deep(.ant-input-affix-wrapper) {
          width: 224px;
          border-radius: 4px;
        }
        ::v-deep(.ant-form-item-label > label) {
          font-size: 14px;
          color: #595959;
        }
        ::v-deep(.ant-form-item:last-child) {
          margin: 0;
        }
      }
      .table {
        margin-top: 16px;
        flex: 1;
        background: #ffffff;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.06);
        border-radius: 4px;
        padding: 24px;
        overflow: hidden;
        .action {
          ::v-deep(.ant-btn) {
            padding: 5px 16px;
            margin-left: 8px;
            border-radius: 4px;
          }
        }
        .table-action {
          display: flex;
          ::v-deep(.ant-btn) {
            padding: 0;
            margin-right: 24px;
          }
        }
      }
    }
    .action {
      flex: 1;
      text-align: right;
      margin-bottom: 16px;
      ::v-deep(.ant-btn) {
        padding: 5px 28px;
        margin-left: 8px;
        border-radius: 4px;
      }
      ::v-deep(.ant-btn > span) {
        font-size: 14px;
        color: #595959;
      }
      ::v-deep(.ant-btn.default-btn) {
        &:hover {
          span {
            color: #40a9ff;
          }
        }
      }
      ::v-deep(.ant-btn-primary > span) {
        color: #ffffff;
      }
    }
  }
}
</style>
